import React from "react";
import MultiPickerSelectedItems from "components/Picker/MultiPickerSelectedItems";
import ProductionList from "./ProductionList";

interface Props {
  selectedProductions: server.dto.ProductionSmallV2[]
  onChange: (newProductions: server.dto.ProductionSmallV2[]) => void
}

const ProductionMultiPicker = (props: Props) => {
  return <MultiPickerSelectedItems
    selectedItems={props.selectedProductions}
    onRemove={props.onChange}
    getId={production => production.productionId}
    getLabel={production => <div>
      {production.name}
    </div>}
  >
    <ProductionList
      onItemSelected={(item) => props.onChange([...props.selectedProductions, item])}
      excludeKeys={props.selectedProductions.map(cc => cc.productionId)}
    />
  </MultiPickerSelectedItems>;
};

export default ProductionMultiPicker;